import styled from 'styled-components';

import { grey1, grey10 } from 'approot/shared/styles/colours.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import { DrawPrintAnswersCanvasInner } from './draw-print-answers-canvas.style';

export const DrawPrint = styled.div`
  background-color: ${grey1};
  margin: auto;
  position: relative;
  overflow: hidden;
  width: 100%;
  border: 1px solid ${grey10};
  border-radius: ${rem(borderRadius16)};
`;

export const DrawPrintButton = styled.div`
  ${SecondaryBaseStyled}

  padding-left: 0;
  padding-right: 0;
  min-width: ${rem(40)};
  height: ${rem(40)};
`;

export const DrawPrintImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  canvas {
    visibility: hidden;
  }

  ${DrawPrintAnswersCanvasInner} {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;

    img {
      width: 100%;
    }
  }
`;
